import React from 'react'
import Table from 'react-bootstrap/Table';
import {fetchOrders,fetchConfirmedOrders,fetchPendingOrders} from '../../../api/api';
import { useTranslation } from 'react-i18next';
import { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const OrderUpdatedHistory = () => {

     const { t } = useTranslation();
     const [orders, setOrders] = useState<any[]>([]);
     const [filter, setFilter] = useState<string>('all');
     const navigate = useNavigate();
       
      const handleFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
          setFilter(e.target.value);
        };

          const loadOrders = async () => {
            try {
              let data: WorkerType[] = [];
        
              if (filter === 'confirmed') {
                data = await fetchConfirmedOrders();
              } else if (filter === 'pending') {
                data = await fetchPendingOrders();
              } else {
                data = await fetchOrders();
              }
        
              if (Array.isArray(data)) {
                setOrders(data);
              } else {
                console.error('Invalid orders data:', data);
                setOrders([]);
              }
            } catch (error) {
              console.error('Error loading orders:', error);
              setOrders([]);
            }
          };
          useEffect(() => {
              loadOrders();
            }, [filter]);
            
      return (
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h4 className="mb-0">{t("orderList")}</h4>
              <select
                className="form-select w-auto"
                value={filter}
                onChange={handleFilterChange}
              >
                <option value="all">{t("allOrders")}</option>
                <option value="confirmed">{t("confirmedOrders")}</option>
                <option value="pending">{t("pendingOrders")}</option>
              </select>
            </div>

            <div className="table-responsive">
              <Table bordered hover>
                <thead>
                  <tr>
                    <th>{t("billNo")}</th>
                    <th>{t("partyName")}</th>
                    <th>{t("date")}</th>
                    <th>{t("total")}</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.length > 0 ? (
                    orders.map((order, index) => (
                      <tr
                        key={index}
                        onClick={() => navigate(`/order/order-history-page/${order.BillNo}`)}

                        style={{ cursor: 'pointer' }}
                      >
                        <td>{order.BillNo}</td>
                        <td>{order.BillPartyName}</td>
                        <td>{order.BillDate}</td>
                      <td>{order.BillNetTotalField}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={4} className="text-center">
                        No orders found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      )
}

export default OrderUpdatedHistory
